import React, { Component } from 'react';

class ErrorBoundary extends Component {
    state = {
        hasError: false,
        errorMessage: ''
    }

    componentDidCatch = (error, info) => {
        this.setState({hasError: true, errorMessage: error});
    }

    routeErrorHandle = () => {
        alert('Leaflet Routing Machine is having technical difficulties . . . try again later')
      }

    render() {
        if (this.state.hasError) {
            alert('Leaflet Routing Machine is having technical difficulties . . . try again later')
            //return <h1>{this.state.errorMessage}</h1>;
        } else {
            return this.props.children;
        }
    }
}

export default ErrorBoundary;